var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_2_",
    "data-name": "home (2)",
    d: "M16.07,6.959h0L9.541.432a1.473,1.473,0,0,0-2.083,0L.934,6.955l-.007.007a1.472,1.472,0,0,0,.98,2.51l.046,0h.26v4.8A1.726,1.726,0,0,0,3.937,16H6.491a.469.469,0,0,0,.469-.469V11.766a.787.787,0,0,1,.787-.786H9.253a.787.787,0,0,1,.787.786v3.766a.469.469,0,0,0,.469.469h2.554a1.726,1.726,0,0,0,1.724-1.724v-4.8h.241A1.473,1.473,0,0,0,16.07,6.959Zm-.664,1.419a.532.532,0,0,1-.379.157h-.71A.469.469,0,0,0,13.848,9v5.272a.787.787,0,0,1-.787.786H10.977v-3.3a1.726,1.726,0,0,0-1.724-1.724H7.746a1.726,1.726,0,0,0-1.724,1.724v3.3H3.937a.787.787,0,0,1-.787-.786V9a.469.469,0,0,0-.469-.469h-.72a.535.535,0,0,1-.369-.913h0L8.121,1.094a.535.535,0,0,1,.757,0L15.4,7.619l0,0A.537.537,0,0,1,15.406,8.379Zm0,0",
    transform: "translate(-0.499)",
    opacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.811d1d80f36ad0a048483487be73d226.svg";
export { ForwardRef as ReactComponent };